import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, Validators } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedService } from '../../../../Services/shared.service';
import { API_End_Point } from '../../../../Services/API_End_Point';
import { Router } from '@angular/router';


@Component({
  selector: 'app-contact',
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule, FormsModule],
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css']
})
export class ContactComponent implements OnInit {
  contactForm!: FormGroup;
  captchaQuestion: string = '';
  captchaAnswer: number = 0;
  captchaInput: string = '';
  captchaError: boolean = false;
  constructor(private fb: FormBuilder, public _svc: SharedService, private router: Router) { }
  ngOnInit(): void {
    this.contactForm = this.fb.group({
      userName: ['', [Validators.required, Validators.maxLength(255)]],
      emailId: ['', [Validators.required, Validators.email, Validators.maxLength(500)]],
      mobileNo: ['', [Validators.required, Validators.pattern('^[0-9]{10}$')]],
      country: ['""'],
      description: ['', [Validators.required, Validators.maxLength(1000)]],
      pinCode: ['000000'],
      city: ['""'],
      state: ['""'],
      schName: ['""'],
      designation: ['""'],
      captchaInput: ['', [Validators.required]]
    });
    this.generateCaptcha();
  }
  generateCaptcha(): void {
    const num1 = Math.floor(Math.random() * 10) + 1;
    const num2 = Math.floor(Math.random() * 10) + 1;
    this.captchaQuestion = "What is:-  " + num1 + "+" + num2 + "?";
    this.captchaAnswer = num1 + num2;
  }
  onSubmit(): void {
    const userCaptcha = this.contactForm.get('captchaInput')?.value;
    if (parseInt(userCaptcha, 10) !== this.captchaAnswer) {
      this.captchaError = true;
      this.contactForm.get('captchaInput')?.reset();
      this.generateCaptcha();
      return;
    }
    this.captchaError = false;
    if (this.contactForm.valid) {
      this._svc.POST(this.contactForm.value, API_End_Point.EnquiryFrom).subscribe({
        next: (res: any) => {
          this._svc.Notification(res.result, res.message);
          if (res.result === 'success') {
            this.router.navigate(['/']);
          }
        },
        error: (err: any) => {
          this._svc.Notification('error', 'Something went wrong. Please try again later.');
        },
        complete: () => {
          this.contactForm.reset({ designation: '' });
          this.captchaInput = '';
          this.generateCaptcha();
        }
      });
    }
  }

  checkCaptcha(event: KeyboardEvent): void {
    const inputValue = (event.target as HTMLInputElement).value;

    if (!inputValue) {
      this.captchaError = false; // empty ho to error na dikhana
      return;
    }

    this.captchaError = parseInt(inputValue, 10) !== this.captchaAnswer;
  }

}